import TableWithFilter from 'components/InternalRequest/Summary/tableWithFilter'

export default function Participated() {
  return <TableWithFilter pageInset={205} retainFilter={true} tab={'participated'} />
}
